import { useSetup } from '@api/useSetup'
import { useEffect } from 'react'
import { initializeAgGrid } from './ag-grid'
import { initializePendo } from './pendo'
import { initializeSentry } from './sentry'

initializeAgGrid()

export function useIntegrations() {
  const { data: setupData } = useSetup()

  useEffect(() => {
    if (setupData) {
      const user = localStorage.getItem('user')
      const env = setupData?.environment

      initializeSentry(env)
      initializePendo(user, env)
    }
  }, [setupData])
}
